// Shared enums for the screw-shear-connector (EC5/NTC2018 timber screw-connection) catalog.
// These sets are fixed and small, so they are rendered as dedicated controls in the
// admin UI instead of dynamic lookups (see ScrewFamilyForm's compatibility matrices).

export const THREAD_TYPES = ["partial", "full"] as const;
export type ThreadType = (typeof THREAD_TYPES)[number];

export const HEAD_TYPES = [
  "countersunk",
  "cylindrical",
  "hexagonal",
  "round_plate",
  "pan_plate",
  "reinforced_pan_plate",
  "hexagonal_pan_plate",
] as const;
export type HeadType = (typeof HEAD_TYPES)[number];

export const TIP_TYPES = ["three_thorns", "self_drilling", "standard", "hardwood"] as const;
export type TipType = (typeof TIP_TYPES)[number];

export const CONNECTION_TYPES = ["shear_screws", "steel_to_timber", "timber_to_timber"] as const;
export type ConnectionType = (typeof CONNECTION_TYPES)[number];

// Connection type of a calculation (screw_connector.calculations.connection_type), distinct from the
// family compatibility categories above. Prefix = element 1 material (legno = timber, acciaio = steel
// plate, pannello = wood-based panel); "3" = three members, screws from both outer sides; "3d" =
// three members, one screw through all of them (double shear).
export const CALCULATION_CONNECTION_TYPES = [
  "legno",
  "legno3",
  "legno3d",
  "acciaio",
  "acciaio3",
  "pannello",
  "pannello3",
  "pannello3d",
] as const;
export type CalculationConnectionType = (typeof CALCULATION_CONNECTION_TYPES)[number];

export const SUBSTRATE_CATEGORIES = [
  "solidwood_softwood",
  "glulam_softwood",
  "clt_softwood",
  "lvl_softwood",
  "solidwood_hardwood",
  "lvl_hardwood",
  "panels",
  "steel",
] as const;
export type SubstrateCategory = (typeof SUBSTRATE_CATEGORIES)[number];

// 0 = not compatible, 1 = restricted, 2 = fully compatible.
export const COMPATIBILITY_LEVELS = [0, 1, 2] as const;
export type CompatibilityLevel = (typeof COMPATIBILITY_LEVELS)[number];

export const RESISTANCE_PARAMS = ["fax_k", "fhead_k"] as const;
export type ResistanceParam = (typeof RESISTANCE_PARAMS)[number];

export const STANDARDS = ["EC5", "NTC2018"] as const;
export type Standard = (typeof STANDARDS)[number];

export const SERVICE_CLASS_CODES = [1, 2, 3] as const;
export type ServiceClassCode = (typeof SERVICE_CLASS_CODES)[number];

export type ConnectionTypeCompatibility = {
  connectionType: ConnectionType;
  compatibilityLevel: CompatibilityLevel;
};

export type SubstrateCompatibility = {
  substrateCategory: SubstrateCategory;
  compatibilityLevel: CompatibilityLevel;
};
